<template>
  <div>
    <div class="row rowSegments mt-4 mb-5 justify-content-md-center ">
      <div class="col-md-11">
        <br /><br />
        <div class="d-flex justify-content-between">
          <h2 class="" style="font-weight: 400">
            Manage Balance
            <br/><br/>
            <a @click="$router.go(-1)" class="backToDashboard text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600">
              <CIcon
                name="arrow"
                :height="20"
                class="icon__rotateLeft"
                viewBox="0 0 32 32"
              />
              BACK TO DASHBOARD
            </a>
          </h2>         
        </div>

        <div class="row mt-5">
          <div class="col-md-4">
            
            <p class="boxTitleIntro mt-3">Your Balance</p>
            <hr>
            <div class="col-md-12" style="background-color: #fff; padding: 25px 50px;">
              <div class="row">
             
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-2">
                      <CIcon style="color: #b3b6bd;" class="mt-2" name="email" :height="45" viewBox="0 0 32 32" />
                      
                    </div>
                    <div class="col">
                      <div style="color: #7f889a; font-size: 14px; "> EMAIL AVAILABLE </div>
                      <div style="color: #7f889a; font-size: 32px;">
                      {{ emailAvailable }}
                      </div>
                    </div>
                </div>
                </div>
             
              </div>
            </div>

            <div class="col-md-12 mt-3" style="background-color: #fff; padding: 25px 50px;">
              <div class="row">
             
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-2">
                      <CIcon style="color: #b3b6bd;" class="mt-2" name="sms" :height="45" viewBox="0 0 32 32" />
                      
                    </div>
                    <div class="col">
                      <div style="color: #7f889a; font-size: 14px; "> SMS AVAILABLE </div>
                      <div style="color: #7f889a; font-size: 32px;">
                      {{ smsAvailable }}
                      </div>
                    </div>
                </div>
                </div>
             
              </div>
            </div>

            <div class="col-md-12" style=" ">
              <table class="byCountry">
                <p style="font-size: 14px; font-weight: bold;" class="boxTitleIntro mt-3 ml-2">BY COUNTRY</p>
                <tbody>
                  <tr v-for="ct in byCountry" :key="ct.count">
                    <td>{{ ct.country }}</td>
                    <td style="text-align: right;">{{ ct.total }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            
            
          </div>
          <div class="col-md-8">
            <div class="d-flex justify-content-between">          
              <p class="boxTitleIntro mt-5">Packs SMS</p>
              <v-select
                style="max-width: 200px; background-color: transparent"
                class="mb-0 no-close my-3"
                :options="countryOptions"
                v-model="countrySelected"
              >
              </v-select>
            </div>
                      
            <hr>
            <div class="col-md-12 row" style="">

                <div 
                  :style="packSMSSelected == index ? 'border: 1px solid #ff5924; background-color: #ffede7;' : ''"
                  class="boxPacks" v-for="(sms, index) in packsSMS" 
                  :key="sms.count" 
                  @click="selectPack(index, 'SMS')"
                >
                <div class="qtdPack">{{ sms.qtd }}</div>
                <div class="typePack">SMS</div>
                <div :style="packSMSSelected == index ? 'background-color: #ff5924 !important; color: #fff;' : ''" class="valuePack">{{ sms.value }}€</div>
                <div class="iconWallet" v-if="packSMSSelected == index">
                  <CIcon name="walletBalance" class="" size="custom-size" label="teste" :height="20" viewBox="0 0 32 32" /> 
                  <span style="" class="ml-1">BUY</span>
                </div>
              </div> 

            </div>

            <p style="margin-top: 80px" class="boxTitleIntro">Packs EMAIL</p>
            <hr>
            <div class="col-md-12 row" style="">
                <div 
                  :style="packEMAILSelected == index ? 'border: 1px solid #ff5924; background-color: #ffede7;' : ''" 
                  class="boxPacks" 
                  v-for="(email, index) in packsEMAIL" 
                  :key="email.count" 
                  @click="selectPack(index, 'EMAIL')"
                >
                <div class="qtdPack">{{ email.qtd }}</div> 
                <div class="typePack">EMAIL</div>
                <div :style="packEMAILSelected == index ? 'background-color: #ff5924 !important; color: #fff;' : ''" class="valuePack">{{ email.value }}€</div>
                <div class="iconWallet" v-if="packEMAILSelected == index">
                  <CIcon name="walletBalance" class="" size="custom-size" label="teste" :height="20" viewBox="0 0 32 32" /> 
                  <span style="" class="ml-1">BUY</span>
                </div>
              </div>
            </div>
            
          </div>

          
        </div>

        

     
      </div>
    </div>
  </div>
</template>

<script>
import services from '@/services.js'
import vSelect from 'vue-select'

export default {
  name: 'AudiencePerformance',
  components: {
    vSelect
  },

  data() {
    return {
      emailAvailable: 1896,
      smsAvailable: 1478,
      byCountry: [
        {
          country: "Portugal",
          total: 452
        },
        {
          country: "Alemanha",
          total: 832
        },
        {
          country: "França",
          total: 354
        },
        {
          country: "Inglaterra",
          total: 232
        },
        {
          country: "Brasil",
          total: 478
        },
      ],
      packsSMS: [
        {
          qtd: '1.000',
          value: 39
        },
        {
          qtd: '5.000',
          value: 180
        },
        {
          qtd: '10.000',
          value: 300
        },
        {
          qtd: '25.000',
          value: 700
        },
      ],
      packsEMAIL: [
        {
          qtd: '10.000',
          value: 10
        },
        {
          qtd: '50.000',
          value: 50
        },
        {
          qtd: '80.000',
          value: 64
        },
        {
          qtd: '300.000',
          value: 150
        },
      ],
      packSMSSelected: null,
      packEMAILSelected: null,
      countrySelected: 'Portugal',
      countryOptions: ['Portugal', 'Espanha', 'Brasil']
    }
  },
  methods: {
    selectPack(indexPack, type){
      if(type == 'SMS'){
        this.packSMSSelected = indexPack
        this.packEMAILSelected = null
      }

      if(type == 'EMAIL'){
        this.packSMSSelected = null
        this.packEMAILSelected = indexPack
      }
    }
  },
  mounted() {
    
  },
  computed: {
    
  }
}
</script>
<style scoped>
.mostUsedTable {
  width: 100%;
  margin-bottom: 1rem;
  color: #7f889a;
}
.mostUsedTable tr {
  border-bottom: 1px solid #e5e5e5;
}

.mostUsedTable td {
  padding: 10px 15px;
  padding-top: 20px;
}

.byCountry {
  width: 100%;
  margin-bottom: 1rem;
  color: #7f889a;
}
.byCountry tr {
  border-bottom: 1px solid #e5e5e5;
}

.byCountry td {
  padding: 10px 15px;
}

.backToDashboard{
  font-size: 14px;
}

.progress {
  background-color: #d1d4da !important;
}

.boxPacks{
  border: 1px solid #d2d2d2;
  min-width: 200px;
  min-height: 150px;
  position: relative;
  margin-right: 15px;
  cursor: pointer;
}

.boxPacks:hover{
  border: 1px solid #ff5924 !important;
  background-color: #ffede7;
}

.boxPacks:hover .valuePack{
  background-color: #ff5924 !important;
  color: white !important;
}

.qtdPack{
  font-size: 30px;
  color: #9699a0;
  text-align: center;
  margin-top: 12%;
}

.typePack{
  color: #9699a0;
  text-align: center;
  margin-top: -5px;
}

.valuePack{
  text-align: center;
  bottom: 0;
  background-color: #ececec;
  color: #9699a0;
  padding: 5px;
  margin-top: 26px;
}

.valuePack:hover{
  background-color: #ff5924 !important;
  color: white !important;
}

.iconWallet{
  position: absolute;
  margin-top: 15px;
  font-size: 13px;
  color: #ff5924;
  font-weight: bold;
  margin-left: 37%;
}
</style>
